
import HeadingText from "../ActionCommonComponent/HeadingText";
import InfoBox from "../../components/InfoBox";
import SignatureBox from "../../components/SignatureBox";
import PasswordField from "../../components/PasswordField";

import UserInfo from "./UserInfo.js";
import RenderHtml from "../../../../common/AppSpecificConpnents/PartsTable/RenderHtml.js";
import { useNavigate } from "react-router-dom";
import RenderCheckbox from "../../../Documents/components/Modals/RenderCheckbox.js";
import RenderArchiveLabel from "../../../Documents/components/Modals/RenderArchiveLabel.js";
import { useS3Data } from "../../../../hooks/useS3Data.js";

const RevisionAction = ({ data={} }) => {

  const { version_id, comment, user_id, new_content_snapshot } = data;

  const { data: s3Data, loading, error } = useS3Data(new_content_snapshot);
  const version_content = s3Data !== null && s3Data !== undefined ? s3Data : data.version_content;

  const { action_to_show } = data?.version_content;

  const navigate = useNavigate()

  const renderActionPersons = () => {
    if (action_to_show === "REVISION_REJECTED") {
      return <UserInfo data={{ name: version_content.rejector }} />;
    } else {
      const arr =
        "required_by" in version_content
          ? version_content.required_by
          : "required_by_details" in version_content
          ? version_content.required_by_details
          : [];

      const users = [arr[0]];
      const approvers = arr
        .filter((a) => a.purpose === "Approve" )
        .map((ap) => ap.user.first_name + " " + ap.user.last_name)
        .join(", ");
      const apprs = { purpose: "Approve", name: approvers };
      users.push(apprs);
      users.push(arr[arr.length - 1]);
      if (action_to_show === "CREATE_PROCEDURE_REVISION") {
        
        return users.map((u, i) => (
          <UserInfo key={"users_" + i} data={u} changeLable={true} />
        ));
      } else if (action_to_show === "REVISION_REQUEST_CHANGE") {
        return (
          <div style={{ marginBottom: "10px" }}>
            <HeadingText
              heading={"Requested By:"}
              text={version_content.requested_by}
              normal={true}
            />
          </div>
        );
      } else if (action_to_show === "REVISION_SENT_FOR_APPROVAL") {
        return <UserInfo data={arr.find(a => a.purpose === "Submit")} />;
      } else if (action_to_show === "REVISION_APPROVED") {
        return <UserInfo data={apprs} />;
      } else if (action_to_show === "REVISION_RELEASED") {
        return <UserInfo data={arr.find(a => a.purpose === "Release")} />;
      }
    }
  };

  const openRevisionPreview = async () => {
    /**Old Implementation */
    // let procedure_revision_id = version_content.procedure_revision_id;

    // // this will only happen in case of action_to_show==="CREATE_PROCEDURE_REVISION"
    // if (!procedure_revision_id) {
    //   const allrev = await dispatch(
    //     getProcedureRevisionsForPart({ partId: version_content.part_ref })
    //   );
    //   procedure_revision_id = allrev.payload.results.find(
    //     (p) => p.rev === version_content.rev
    //   )?.procedure_revision_id;
    // }

    // const response = await dispatch(
    //   getProcedureRevisionById(procedure_revision_id)
    // );
    // const revData = response.payload.results;

    // RedirectToRevision({
    //   type_name: revData.part_data?.type?.name,
    //   part_number: revData.part_data?.part_number,
    //   procedureRevisionId: revData.procedure_revision_id,
    //   description: revData.part_data?.description,
    //   status: version_content.current_status,
    //   partId: revData.part_data?.part_id,
    //   revision: revData.rev,
    // });
    /**End Old Implementation */

    // New Implementation
    navigate("/audit-trail/revision-preview/"+data.audit_trail_id)
    
  };
  return (
    <>
      <HeadingText heading="Associated Version" text={version_id} />
      <HeadingText heading="Activity" text={data.action} />
      <HeadingText heading="Details (Read Only)">
        <InfoBox
          heading={
            action_to_show === "REVISION_REJECTED"
              ? "Reject Revision from Release"
              : action_to_show === "CREATE_PROCEDURE_REVISION"
              ? "Draft New Revision"
              : action_to_show === "REVISION_SENT_FOR_APPROVAL"
              ? "Submit Revision for Approval"
              : action_to_show === "REVISION_REQUEST_CHANGE"
              ? "Request Changes for Revision"
              : action_to_show === "REVISION_APPROVED"
              ? "Approve Revision for Release"
              : action_to_show === "REVISION_RELEASED"
              ? "Release Revision to Production"
              : action_to_show === "REVISION_ARCHIVED"
              ? "Revision Archived"
              : ""
          }
          buttons={[
            {
              text: "Preview Document Reviewed",
              onClick: openRevisionPreview,
              // disabled: version_content.selectedTemplate && version_content.selectedTemplate ==="Blank" ? true : false,
            },
          ]}
        >
          <div style={{ marginBottom: "20px" }}>
            <span className="big-heading">
              {version_content?.type} {version_content?.procedure_number}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;<RenderHtml content={version_content?.description} />
          </div>

          <div style={{ marginBottom: "10px" }}>
            <HeadingText
              heading="Revision:"
              text={
                <>
                  {version_content?.rev}{" "}
                  <RenderArchiveLabel
                    revisionToArchive={version_content?.revisionToArchive}
                  />
                </>
              }
              normal={true}
            />
          </div>

          {"selectedTemplate" in version_content && (
            <>
              <div style={{ marginBottom: "10px" }}>
                <HeadingText
                  heading="Select Template:"
                  text={<RenderHtml content={version_content?.selectedTemplate} />}
                  normal={true}
                />
              </div>
            </>
          )}

          {action_to_show === "CREATE_PROCEDURE_REVISION" && (
            <div style={{ marginBottom: "10px" }}>
              <HeadingText
                heading="Requested By:"
                text={version_content?.requested_by }
                normal={true}
              />
            </div>
          )}

          {renderActionPersons()}

          <label>
            {action_to_show === "CREATE_PROCEDURE_REVISION"
              ? "Revision Details"
              : action_to_show === "REVISION_REQUEST_CHANGE"
              ? "Changes Requested"
              : "Comment"}<span style={{ color: "#0D6EFD", marginLeft: "-1px" }}>*</span>
          </label>
          <textarea
            class="input-textarea"
            disabled
            style={{ marginBottom: "20px", resize: "none" }}
            value={comment}
            rows={6}

          ></textarea>

          {action_to_show !== "CREATE_PROCEDURE_REVISION" && (
            <>
              {
                action_to_show === "REVISION_RELEASED" ? (
                  <>{
                    version_content?.revisionsToReject?.length>0 ? <RenderCheckbox 
                      revisionsToReject={version_content?.revisionsToReject || []}
                      readOnly={true}
                      isChecked={true}
                    /> : <div style={{ marginTop: "-20px" }}></div>
                    }
                  </>
                ) : (
                  <>
                    <input type="checkbox" id="reviewed" disabled checked />
                    <label htmlFor="reviewed" style={{ display: "inline" }}>
                      <span style={{ fontWeight: "400 !important" }}>
                        I have reviewed the revisions mentioned on previous screen.
                      </span>
                      <span style={{ color: "#0D6EFD", marginLeft: "-1px" }}>*</span>
                    </label>
                  </>
                )
              }
              
            </>
          )}
          {
            version_content.is_password_included && (
              <PasswordField password_bullets={version_content?.password_bullets} />
            )
          }
          {
            version_content.is_signature_included && (
              <>
              <label style={{ marginTop: "20px" }}>Sign Here<span style={{ color: "#0D6EFD", marginLeft: "-1px" }}>*</span></label>
              <SignatureBox signature={version_content?.signature}/>
              </>
            )
          }
        </InfoBox>
      </HeadingText>
    </>
  );
};

export default RevisionAction;
